export * from './promotion-aside';